import React, { Component } from 'react';
import Icon from 'icons/Icon';
import { currency } from '../../util/Currency';
import { GraphInformationJsonModel } from '../../domain/graph/GraphDomains';
import DataType from '../../constant/DataType';
import NavigationUtil from '../../util/NavigationUtil';
import LanguageUtil from '../../util/LanguageUtil';

class GraphNodeInformationComponent extends Component<Props> {
  private readonly informationRef: React.RefObject<HTMLDivElement> = React.createRef<HTMLDivElement>();

  public render() {
    const { visible, coordinates } = this.props;
    return (
      <div
        ref={this.informationRef}
        style={{ top: coordinates?.y, left: coordinates?.x }}
        className={`${visible ? 'flex opacity-100 z-[50]' : 'flex opacity-0 z-[-1]'} " flex-col overflow-scroll transition-all ease-in-out  duration-700 rounded-lg min-h-[230px] w-[500px] h-auto max-h-[250px] border-[1px] border-f-black-5  absolute bg-main-gray`}
      >
        {this.getVisibleHeader()}
        {this.getContent()}
      </div>
    );
  }

  public componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  private getVisibleHeader = () => {
    const { nodeInformationJsonModel } = this.props;
    return (
      <div className={`flex sticky top-0 items-center justify-between w-full px-2 py-3 bg-main-gray border-b border-[#E0E4E8] text-xl`}>
        <span className={'flex w-full items-center gap-x-2 text-md'}>
          <div
            className={'w-6 h-6 rounded-full text-xs'}
            style={{
              backgroundColor: nodeInformationJsonModel?.node?.nodeColor,
              border: `2px solid ${nodeInformationJsonModel?.node?.strokeColor}`,
            }}
          ></div>
          <p>{nodeInformationJsonModel?.nodeInfo?.key?.toString() || 'This node has not a label'}</p>
        </span>
        {!this.props.isCasePage && (
          <span className={'w-full text-sm flex items-center justify-end gap-[8px] text-underline'}>
            <p className='cursor-pointer' onClick={this.addToFilter}>
              <Icon icon='filter_icon' className='cursor-pointer fill-f-black-2' size={16} />
            </p>
            <p className='cursor-pointer' onClick={this.navigateTransaction}>
              <Icon icon='select_transaction_icon' className='cursor-pointer fill-f-black-2' size={16} />
            </p>
          </span>
        )}
      </div>
    );
  };

  private addToFilter = () => {
    const { nodeInformationJsonModel, onChangeFilter } = this.props;
    const [key, value] = nodeInformationJsonModel?.node?.key?.toString().split('-') || ['', ''];
    const newFilter = {
      filterType: 'ConditionalFilter',
      type: 'and',
      filters: [
        {
          filterType: 'MatchFilter',
          key: 'variables.' + key + '.keyword',
          type: 'eq',
          value: value,
        },
      ],
    };
    onChangeFilter?.(newFilter);
  };

  private getContent = () => {
    const { nodeInformationJsonModel } = this.props;
    if (nodeInformationJsonModel == undefined) {
      return (
        <div className={'flex flex-col gap-y-5 px-5 py-5 items-center justify-center w-full h-full'}>
          <Icon icon={'no-folder'} className={'text-f-purple'} size={50} />
          <span className={'text-f-purple font-bold text-lg'}>
            {LanguageUtil.get({ id: 'pages.graph.pleaseSelectNode', defaultMessage: 'Please select a node' })}
          </span>
        </div>
      );
    }
    return (
      <div className={'flex flex-col'}>
        <div className={'flex w-full gap-x-2 odd:bg-white border-b border-[#E0E4E8] gap items-between px-5 py-2'}>
          <span className={'text-f-black-2  text-md w-full flex items-center gap-x-3'}>
            <Icon icon={'number'} size={20} />
            {LanguageUtil.get({ id: 'pages.graph.node.connectionCount', defaultMessage: 'Connection Count' })}
          </span>
          <span className={'text-f-black-2 w-full truncate flex items-center justify-end text-md'}>
            {(nodeInformationJsonModel?.node as any)?.connectionCount || 0}
          </span>
        </div>
        <div className={'flex w-full gap-x-2 odd:bg-white border-b border-[#E0E4E8] gap items-between px-5 py-2'}>
          <span className={'text-f-black-2 text-md w-full flex items-center gap-x-3'}>
            <Icon icon={'transaction'} size={20} />
            {LanguageUtil.get({ id: 'pages.graph.node.totalTransactionCount', defaultMessage: 'Total Transaction Count' })}
          </span>
          <span className={'text-f-black-2 w-full truncate flex items-center justify-end  text-md'}>
            {nodeInformationJsonModel?.nodeInfo?.totalTransactionCount || 0}
          </span>
        </div>
        <div className={'flex w-full gap-x-2 odd:bg-white border-b border-[#E0E4E8] gap items-between px-5 py-2'}>
          <span className={'text-f-black-2 text-md w-full flex items-center gap-x-3'}>
            <Icon icon={'function_sum'} size={20} />
            {LanguageUtil.get({ id: 'pages.graph.node.totalTransactionAmount', defaultMessage: 'Total Transaction Amount' })}
          </span>
          <span className={'text-f-black-2 w-full truncate flex items-center justify-end text-md'}>
            {(this.props.currencyConfiguration &&
              nodeInformationJsonModel.nodeInfo?.totalTransactionAmount?.toLocaleString('en-US', {
                style: 'currency',
                currency: currency[this.props?.currencyConfiguration as string]?.code,
                minimumFractionDigits: 0,
              })) ||
              0}
          </span>
        </div>
        <div className={'flex w-full gap-x-2 odd:bg-white border-b border-[#E0E4E8] gap items-between px-5 py-2'}>
          <span className={'text-f-black-2  text-md w-full flex items-center gap-x-3'}>
            <Icon icon={'info'} size={20} />
            {LanguageUtil.get({ id: 'pages.graph.node.fraudulentTransactionCount', defaultMessage: 'Fraudulent Transaction Count' })}
          </span>
          <span className={'text-f-black-2 w-full truncate flex items-center justify-end text-md'}>
            {nodeInformationJsonModel.nodeInfo?.fraudulentCaseCount || 0}
          </span>
        </div>
        <div className={'flex w-full gap-x-2 odd:bg-white border-b border-[#E0E4E8] gap items-between px-5 py-2'}>
          <span className={'text-f-black-2  text-md w-full flex items-center gap-x-3'}>
            <Icon icon={'function_sum'} size={20} />
            {LanguageUtil.get({ id: 'pages.graph.node.fraudulentTransactionCount', defaultMessage: 'Fraudulent Transaction Count' })}
          </span>
          <span className={'text-f-black-2 w-full truncate flex items-center justify-end text-md'}>
            {(this.props.currencyConfiguration &&
              nodeInformationJsonModel.nodeInfo?.fraudulentCaseAmount?.toLocaleString('en-US', {
                style: 'currency',
                currency: currency[this.props?.currencyConfiguration]?.code,
                minimumFractionDigits: 0,
              })) ||
              0}
          </span>
        </div>
      </div>
    );
  };

  private handleClickOutside = (event: any) => {
    const { onChangeVisible } = this.props;
    if (this.informationRef.current && !this.informationRef.current.contains(event.target)) {
      onChangeVisible(false);
    }
  };

  private navigateTransaction = () => {
    const { nodeInformationJsonModel, configurationName } = this.props;
    if (nodeInformationJsonModel == undefined || configurationName == undefined) return;
    const searchParams = new URLSearchParams();
    const field = nodeInformationJsonModel?.node?.group;
    const value = nodeInformationJsonModel?.nodeInfo?.key;
    const filter = [
      {
        field,
        value,
        operator: 'eq',
        dataType: DataType.STRING,
      },
    ];
    searchParams.set('filters', JSON.stringify(filter));
    window.open(`/${NavigationUtil.getTenant()}/cases/${configurationName}?${searchParams.toString()}`, '_blank');
  };
}

interface Props {
  nodeInformationJsonModel: GraphInformationJsonModel | undefined;
  visible: boolean;
  onChangeVisible: (visible: boolean) => void;
  isCasePage?: boolean;
  coordinates?: { x: number; y: number };
  onChangeFilter?: (filter: any) => void;
  currencyConfiguration?: string;
  configurationName?: string;
}

export default GraphNodeInformationComponent;
